const _excluded = ["className"];
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/thumb_navigation.tsx";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';
import { usePopper } from 'react-popper';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { getPinnedHosts } from 'soapbox/actions/remote_timeline';
import { openSidebar } from 'soapbox/actions/sidebar';
import ThumbNavigationLink from 'soapbox/components/thumb_navigation-link';
import { Text } from 'soapbox/components/ui';
import { useAppSelector, useLogo, useOwnAccount } from 'soapbox/hooks';
import { getFeatures } from 'soapbox/utils/features';
import { Avatar } from './ui';
function calculateBottom(node) {
  if (!node) return 0;
  const {
    bottom
  } = node.getBoundingClientRect();
  const height = window.innerHeight;
  return height - bottom;
}
const PinnedHosts = () => {
  const node = useRef(null);
  const [bottom, setBottom] = useState(0);
  const pinnedHosts = useAppSelector(s => getPinnedHosts(s));
  useEffect(() => {
    setBottom(calculateBottom(node.current));
    node.current?.scrollBy(0, 100000000);
  }, [pinnedHosts]);
  if (pinnedHosts.isEmpty()) return null;
  return /*#__PURE__*/React.createElement("div", {
    ref: node,
    className: "overflow-y-auto overscroll-contain",
    style: {
      maxHeight: `calc(100vh - ${bottom}px)`
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-max flex flex-col gap-3 pl-4 justify-start items-start",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }, pinnedHosts.sort((a, b) => b.get('host').length - a.get('host').length).map(instance => /*#__PURE__*/React.createElement(Link, {
    className: "border-[1px] border-solid border-slate-500 shadow-md bg-white rounded-full dark:bg-slate-900 px-4 py-3  flex items-center gap-2",
    to: `/timeline/${instance.get('host')}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: instance.get('host'),
    src: instance.get('favicon'),
    width: 16,
    height: 16,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 15
    }
  }, instance.get('host'))))));
};
const Communities = () => {
  const features = getFeatures(useAppSelector(state => state.instance));
  const instance = useAppSelector(state => state.instance);
  const logo = useLogo();
  const hasBubble = useMemo(() => {
    const localBubbleInstance = instance.pleroma.getIn(['metadata', 'federation', 'local_bubble_instances']);
    if (!localBubbleInstance) return false;
    return localBubbleInstance.size > 0;
  }, [instance.pleroma]);
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-2xl bg-white !bg-opacity-60 border-solid border-[1px] border-slate-100 dark:border-slate-700 dark:bg-slate-800 backdrop-blur-xl w-max flex gap-2 p-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 5
    }
  }, features.federating ? /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    className: "py-0",
    src: logo,
    text: instance.get('title'),
    to: "/timeline/local",
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 11
    }
  }) : /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    className: "py-0",
    src: require('@tabler/icons/world.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.all",
      defaultMessage: "All",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 19
      }
    }),
    to: "/timeline/local",
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 11
    }
  }), features.federating && features.bubbleTimeline && hasBubble && /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    className: "py-0",
    src: require('@tabler/icons/hexagon.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.bubble",
      defaultMessage: "Featured",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 19
      }
    }),
    to: "/timeline/bubble",
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 11
    }
  }), features.federating && /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    className: "py-0",
    src: require('icons/fediverse.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.fediverse",
      defaultMessage: "Explore",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 107,
        columnNumber: 19
      }
    }),
    to: "/timeline/fediverse",
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 11
    }
  }));
};
const CommunityTimelineMenu = ({
  referenceElement,
  onClose
}) => {
  const [popperElement, setPopperElement] = React.useState(null);
  const {
    styles,
    attributes
  } = usePopper(referenceElement, popperElement, {
    placement: 'top',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }]
  });
  const handleClickOutside = React.useCallback(e => {
    if (popperElement.contains(e.target)) return;
    onClose(e);
  }, [onClose, popperElement]);
  React.useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, [handleClickOutside]);
  return /*#__PURE__*/ReactDOM.createPortal(
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  React.createElement("div", _extends({
    ref: setPopperElement,
    onClick: onClose,
    className: "z-50 flex flex-col gap-3",
    style: styles.popper
  }, attributes.popper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(PinnedHosts, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Communities, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 154,
      columnNumber: 7
    }
  })), document.body);
};
const ThumbNavigation = _ref => {
  let {
      className = ''
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const account = useOwnAccount();
  const {
    pathname
  } = useLocation();
  const dispatch = useDispatch();
  const notificationCount = useAppSelector(state => state.notifications.unread);
  const [showCommunityMenu, setShowCommunityMenu] = React.useState(null);
  const handleCommunityClick = React.useCallback(e => {
    e.stopPropagation();
    setShowCommunityMenu(e.currentTarget);
  }, []);
  const onOpenSidebar = React.useCallback(() => dispatch(openSidebar()), [dispatch]);

  // we close community menu when route changes
  React.useEffect(() => {
    setShowCommunityMenu(null);
  }, [pathname]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `thumb-navigation fixed lg:hidden rounded-2xl bottom-2 mx-auto bg-white !bg-opacity-60 border-solid border-[1px] border-slate-100 dark:border-slate-700 dark:bg-slate-800 backdrop-blur-xl left-0 right-0 shadow-2xl w-[95%] flex z-50 flex items-center ${className}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    src: require('@tabler/icons/home.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation.home",
      defaultMessage: "Home",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 185,
        columnNumber: 17
      }
    }),
    to: "/",
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 183,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    active: pathname.startsWith('/timeline'),
    src: require('@tabler/icons/building-community.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation.community",
      defaultMessage: "Community",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 193,
        columnNumber: 17
      }
    }),
    onClick: handleCommunityClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 190,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    src: require('@tabler/icons/search.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "column.search",
      defaultMessage: "Search",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 199,
        columnNumber: 17
      }
    }),
    to: "/search",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 197,
      columnNumber: 9
    }
  }), account && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    src: require('@tabler/icons/bell.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation.notifications",
      defaultMessage: "Alerts",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 208,
        columnNumber: 21
      }
    }),
    to: "/notifications",
    exact: true,
    count: notificationCount,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 206,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "mx-3 bg-transparent border-0",
    onClick: onOpenSidebar,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: account.avatar,
    size: 32,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 15
    }
  })))), showCommunityMenu && /*#__PURE__*/React.createElement(CommunityTimelineMenu, {
    referenceElement: showCommunityMenu,
    onClose: () => setShowCommunityMenu(null),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 221,
      columnNumber: 30
    }
  }));
};
export default ThumbNavigation;